unit f_visite;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  DateUtils, f_selezione, w_edit, un_servermodule, w_label,
  un_telemetria, UnArrayDef, DB, un_user, f_VisiteInserisci, f_visitemodifica;

type

  TVisibilita = (visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso);
const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo le ultime 300 visite' ;
  msgDateErrate = 'Correggi le date corrette per visualizzare le visite';
  msgNessunRecord = 'Nessuna visita da visualizzare';
  msgCaricamentoInCorso = 'Nessuna visita da visualizzare...';
//  msgCaricamentoInCorso = 'Caricamento trasporti in corso...';

type
  { TFrmVisite }

  TFrmVisite = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate :String;
    dt1str, dt2str :String;
    function DateOk:Boolean;
    procedure RefreshTrasporti; async;
    procedure QryTrasportiOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita:TVisibilita);
  published
    procedure tab1_rowclick; async;
    procedure filtro_change;
    procedure filtro_input;
    procedure impostadate;
    procedure data1_change;
    procedure data2_change;
    procedure nuovavisita_click; async;
    procedure provvisori_click; async;
    procedure flvisite_click; async;
    procedure fldisabili_click; async;
    procedure stampa1_click(event: TJSEvent); async;
    stampa1 :TJSHTMLButtonElement;
    procedure stampa2_click(event: TJSEvent); async;
    stampa2 :TJSHTMLButtonElement;
    data1 : TJSHTMLInputElement;
    data2 : TJSHTMLInputElement;
    filtro: TWEdit;
    edit2: TJSHTMLInputElement;
    idriepilogo: TJSHTMLInputElement;
    provvisori: TJSHTMLInputElement;
    flvisite: TJSHTMLInputElement;
    fldisabili: TJSHTMLInputElement;
    pnltab1: TJSHTMLElement;
    QryTrasporti: TQuery;
    tab1:TWTable;
    labelTop:TWLabel;
    labelBottom:TWLabel;
  end;

implementation

{$R *.html}

{ TFrmVisite }

procedure TFrmVisite.AfterRender;
begin

  QryTrasporti.OnFilterRecord := @QryTrasportiOnFilterRecord;

  filtro.placeholder := 'Ricerca visite...';
  filtro.seleziona1.Visible:= false;

  labelTop.header.innerHTML:= '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML:= '<br><br>';

  labelBottom.labelbody.innerHTML:= 'bottom';
  labelBottom.header.innerHTML:= '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  impostadate;

  RefreshTrasporti;

end;


procedure TFrmVisite.QryTrasportiOnFilterRecord(DataSet: TDataSet;
  var Accept: Boolean);
var
  str:String;
  i: Integer;
begin
  Accept:= true;
  str := filtro.value.ToLowerInvariant;
  for i:= 0 to DataSet.FieldCount-1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
         exit;
  end;
  //nessun campo matcha la stringa cercata
  Accept := false;
end;


procedure TFrmVisite.SetLabel(lbl:TWLabel;value:String);
begin
  lbl.Visible := value <> '' ;
  lbl.labelbody.innerHTML := value;
end;


procedure TFrmVisite.ImpostaVisibilita(visibilita:TVisibilita);
begin
  //visDateErrate,visNessunRecord,visLimiteRecord,visCiSonoRecord,visCaricamentoInCorso
  SetLabel(labelTop,'');
  SetLabel(labelBottom,'');

  if visibilita = visDateErrate then SetLabel(labelTop,msgDateErrate);
  if visibilita = visNessunRecord then SetLabel(labelBottom,msgNessunRecord);
  if visibilita = visLimiteRecord then SetLabel(labelBottom,msgLimiteRecord);
  if visibilita = visCaricamentoInCorso then SetLabel(labelBottom,msgCaricamentoInCorso);

  filtro.Visible := visibilita <> visDateErrate;
//  console.log(format(' filtro.Visible := %s',[BoolToStr(filtro.Visible,true)]));
  pnltab1.Visible:= visibilita in [visLimiteRecord,visCiSonoRecord];
end;


procedure TFrmVisite.tab1_rowclick;
var
  instance: TFrmVisiteModifica;
begin

  if QryTrasporti.FieldByName('prov').AsString <> 'P' then
  begin
    ShowMessage('Puoi modificare solo le visite con P di provvisorio... ');
    Exit;
  end;

  instance := TFrmVisiteModifica.Create();
  instance.idtrasporto := QryTrasporti.FieldByName('idtrasporto').AsInteger;
  Await(instance.show);

  // Refresh dopo la modifica
  Await(RefreshTrasporti);

end;


procedure TFrmVisite.RefreshTrasporti;
var
  filtroTipo: String;
begin

  if not DateOk then
  begin
    ImpostaVisibilita(visDateErrate);
    exit;
  end;

  ImpostaVisibilita(visCaricamentoInCorso);

  filtroTipo := '';

  // =====================================================
  // FILTRO VISITE / DISABILI
  //
  // VISITE   = IDTIPORICHIESTA = 5
  // DISABILI = IDTIPORICHIESTA = 4
  //
  // Se entrambi sono selezionati:
  // IDTIPORICHIESTA = 5 OR IDTIPORICHIESTA = 4
  // =====================================================

  if flvisite.checked and fldisabili.checked then
  begin
    filtroTipo := '(IDTIPORICHIESTA = 5 OR IDTIPORICHIESTA = 4)';
  end
  else if flvisite.checked then
  begin
    filtroTipo := 'IDTIPORICHIESTA = 5';
  end
  else if fldisabili.checked then
  begin
    filtroTipo := 'IDTIPORICHIESTA = 4';
  end;

  QryTrasporti.Close;

  QryTrasporti.SQL.Text :=
      ' select idtrasporto, flprovvisorio as prov, dtdata as data, horapartenza as hpart, '
    + ' horaarrivo as harr, dstiporichiesta as rich, idfruitore as id1, dsfruitore as utente, '
    + ' dsindirizzopartenza as indpartenza, '
    + ' idfruitore2 as id2, dsfruitore2 as destinazione, dsindirizzoarrivo as indarrivo, '
    + ' dstelefono as telef, dsnote as note '
    + ' from ta_trasporti '
    + ' where idsocieta = ''DON001'' '
    + ' and ' + whereDate;

  // =====================================================
  // FILTRO VISITE / DISABILI
  //
  // Se nessuno dei due è selezionato:
  // visualizzo entrambe le categorie.
  // =====================================================

  if filtroTipo <> '' then
  begin
    QryTrasporti.SQL.Text :=
        QryTrasporti.SQL.Text
      + ' and ' + filtroTipo;
  end
  else
  begin
    QryTrasporti.SQL.Text :=
        QryTrasporti.SQL.Text
      + ' and (IDTIPORICHIESTA = 5 OR IDTIPORICHIESTA = 4)';
  end;

  // =====================================================
  // FILTRO PROVVISORI
  //
  // Questo è un filtro AGGIUNTIVO.
  //
  // Se Provvisori è selezionato:
  //
  //     AND FLPROVVISORIO = 'P'
  //
  // Quindi:
  //
  // Visite + Provvisori =
  //     IDTIPORICHIESTA = 5
  //     AND FLPROVVISORIO = 'P'
  //
  // Visite + Disabili + Provvisori =
  //     (IDTIPORICHIESTA = 5 OR IDTIPORICHIESTA = 4)
  //     AND FLPROVVISORIO = 'P'
  // =====================================================

  if provvisori.checked then
  begin
    QryTrasporti.SQL.Text :=
        QryTrasporti.SQL.Text
      + ' and FLPROVVISORIO = ''P''';
  end;

  QryTrasporti.SQL.Text :=
      QryTrasporti.SQL.Text
    + ' order by dtdata, dsautista, horapartenza ';

  AWait(QryTrasporti.Open);

  QryTrasporti.FieldByName('IDTRASPORTO').Visible:= false;
  QryTrasporti.FieldByName('ID1').Visible:= false;
  QryTrasporti.FieldByName('ID2').Visible:= false;

  RefreshFiltro;
end;


procedure TFrmVisite.RefreshFiltro;
begin
  QryTrasporti.Filtered:= filtro.value.Trim <> '';
  QryTrasporti.First;
  tab1.RenderDataSet(QryTrasporti);

  if QryTrasporti.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryTrasporti.RecordCount = limiteRecord then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);
end;


procedure TFrmVisite.filtro_change;
begin
  RefreshFiltro;
end;


procedure TFrmVisite.filtro_input;
begin
  RefreshFiltro;
end;


procedure TFrmVisite.impostadate;
begin
  data1.value:=FormatDateTime('yyyy-mm-dd',Date);
  data2.value:=FormatDateTime('yyyy-mm-dd',Date + 90);
end;


procedure TFrmVisite.data1_change;
begin

  window.localStorage[ClassName+'_data1'] := data1.value;

  RefreshTrasporti;

end;


procedure TFrmVisite.data2_change;
begin

  window.localStorage[ClassName+'_data2'] := data2.value;

  RefreshTrasporti;

end;


procedure TFrmVisite.nuovavisita_click;
var
  instance: TFrmVisiteInserisci;
begin

  instance := TFrmVisiteInserisci.Create();
  Await(instance.show);

  // Ricarico l'elenco delle visite
  Await(RefreshTrasporti);

end;


procedure TFrmVisite.provvisori_click;
begin
  RefreshTrasporti;
end;


procedure TFrmVisite.flvisite_click;
begin
  RefreshTrasporti;
end;


procedure TFrmVisite.fldisabili_click;
begin
  RefreshTrasporti;
end;


procedure TFrmVisite.stampa2_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '137';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  clausola := format(
    'AND IDTRASPORTO IN (%s)',
    [ToCommaText(QryTrasporti,'IDTRASPORTO',true)]
  );

  sql := SysUtils.StringReplace(sql,'--AND1',clausola,[]);

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '137';
    Params['sql'] := sql;
    Params['DATADA'] := dt1str;
    Params['DATAA'] := dt2str;
    window.open(Url,'_blank');
  end;

  TmRegistraEvento(
    'stampa_trasporti',
    format(
      '%s ~ %s|filtro=%s',
      [data1.value,data2.value,filtro.Value]
    )
  );

end;


procedure TFrmVisite.stampa1_click(event: TJSEvent);
var
  sql, clausola: String;
begin

  with ServerModule('TWebStampe') do
  begin
    Params['idStampa'] := '136';
    AWait(Call('WebParametri'));
    sql := Response.Strings['SQL'];
  end;

  clausola := format(
    'AND IDTRASPORTO IN (%s)',
    [ToCommaText(QryTrasporti,'IDTRASPORTO',true)]
  );

  sql := SysUtils.StringReplace(sql,'--AND1',clausola,[]);

  with ServerModule('TWebStampe') do
  begin
    Proc := 'WebProcessa';
    Params['idStampa'] := '136';
    Params['sql'] := sql;
    Params['DATADA'] := dt1str;
    Params['DATAA'] := dt2str;
    window.open(Url,'_blank');
  end;

  TmRegistraEvento(
    'stampa_trasporti',
    format(
      '%s ~ %s|filtro=%s',
      [data1.value,data2.value,filtro.Value]
    )
  );

end;


function TFrmVisite.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
begin

  Result := false;

  if (data1.value = '') or (data2.value = '')
    or (data1.value > data2.value) then
  begin
    SetLabel(labelTop,msgDateErrate);
    SetLabel(labelBottom,'');
    exit;
  end;

  Result := true;

  dt1 := ScanDateTime('yyyy-MM-dd',data1.value);
  dt2 := ScanDateTime('yyyy-MM-dd',data2.value);
  dt2 := IncDay(dt2);

  // questo formato date serve per la query
  dt1str := FormatDateTime('dd.MM.yyyy',dt1);
  dt2str := FormatDateTime('dd.MM.yyyy',dt2);

  whereDate := ' dtdata >= ''' + dt1str + ''''
    + ' and dtdata < ''' + dt2str + '''';

  // questo formato di date serve alla stampa
  dt1str := FormatDateTime('dd/MM/yyyy',dt1) + ' 00:00:00';
  dt2str := FormatDateTime('dd/MM/yyyy',dt2) + ' 00:00:00';

end;


initialization
  RegisterWeb(TFrmVisite);

end.

